
function redirect( path: string ) {
  return {
    augId: 'redirect',
    path
  };
}

export default redirect;
